import React, { useRef } from 'react';
import { classNames } from 'primereact/utils';
import { CSSTransition } from 'react-transition-group';
import { AppSubmenuProps, CommandArgs, SideBarItem } from './AppMenuTypes';
import AppMenuLink from './AppMenuLink';

type AppMenuItemProps = {
  item: SideBarItem;
  index: number;
  active: boolean;
  root?: boolean;
  menuMode: 'static' | 'horizontal' | 'slim';
  menuActive: boolean;
  onMenuItemClick: (
    e: React.SyntheticEvent,
    item: SideBarItem,
    index: number
  ) => void;
  onSubmenuItemClick: ({ originalEvent, item }: CommandArgs) => void;
  isSubmenuOpen: (item: SideBarItem, active: boolean) => boolean;
  transitionTimeout: number | { enter: number; exit: number };
  Submenu: React.ForwardRefExoticComponent<
    AppSubmenuProps & React.RefAttributes<HTMLUListElement>
  >;
};

const AppMenuItem = ({
  item,
  index,
  active,
  root,
  menuMode,
  menuActive,
  onMenuItemClick,
  onSubmenuItemClick,
  isSubmenuOpen,
  transitionTimeout,
  Submenu,
}: AppMenuItemProps) => {
  const submenuRef = useRef<HTMLUListElement>(null);
  const styleClass = classNames(
    `${item.badgeStyleClass} sidebarItem mt-2 sm:mt-4`,
    { active: active },
    { 'layout-root-menuitem': root }
  );

  return (
    <li className={styleClass}>
      <AppMenuLink
        item={item}
        index={index}
        root={root}
        onMenuItemClick={onMenuItemClick}
      />
      {root && (
        <div>
          <span
            className="layout-menuitem-text"
            style={{ textTransform: 'uppercase' }}
          >
            {item.label}
          </span>
        </div>
      )}
      <CSSTransition
        nodeRef={submenuRef}
        classNames="layout-submenu-container"
        timeout={transitionTimeout}
        in={isSubmenuOpen(item, active)}
        unmountOnExit
      >
        <Submenu
          ref={submenuRef}
          items={item.items}
          onMenuItemClick={onSubmenuItemClick}
          menuMode={menuMode}
          menuActive={menuActive}
          parentMenuItemActive={active}
        />
      </CSSTransition>
    </li>
  );
};

export default AppMenuItem;
